var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _vm.href ? "a" : "button",
    {
      tag: "component",
      staticClass:
        "analyses-category-card d-flex flex-column justify-space-between text-decoration-none rounded-lg pa-3",
      class: { "analyses-category-card--button": !_vm.href },
      attrs: {
        "data-qa": "analyses_category_card",
        href: _vm.href || undefined,
        type: _vm.href ? undefined : "button",
      },
      on: { click: _setup.onClick },
    },
    [
      _c("div", { staticClass: "text-subtitle-2 text--text" }, [
        _vm._v("\n    " + _vm._s(_vm.name) + "\n  "),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass:
          "analyses-category-card__icon align-self-end flex-shrink-0",
        attrs: { src: _vm.icon, alt: "" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }